const es_MX = {
  "colorpicker.opacity-input": "Opacidad",
  "datepicker.clear-date": "Borrar fecha",
  "datepicker.next-month": "Próximo mes",
  "datepicker.open-calendar": "Abrir calendario",
  "datepicker.previous-month": "Mes anterior",
  "input.clear": "Borrar entrada",
  "input.hide-password": "Ocultar contraseña",
  "input.show-password": "Mostrar contraseña",
  "modal.close": "Cerrar",
  "multiselectchips.add-value": "Agregar ‘{value}’",
  "multiselectchips.remove-all": "Eliminar todo",
  "pagination.next-page": "Siguiente página",
  "pagination.previous-page": "Página anterior"
};
export {
  es_MX as default
};
//# sourceMappingURL=es_MX.json.js.map
